import { ApiError } from '@lib/api/api-response';

/**
 * An upload rejection whose message was written for the person uploading —
 * wrong file type, too large, a Storage refusal we translated. Callers show
 * `message` verbatim.
 *
 * Being an ApiError keeps it compatible with the shared transport handling
 * (the Clerk-401 gate, retry predicates). The class, not the status, is what
 * marks the copy as safe to display: plenty of 4xx bodies reaching this flow
 * are server-authored ("Validation failed", "Forbidden", "Deal not found")
 * and must stay behind a generic line.
 */
export class UploadRejectedError extends ApiError {
  constructor(message: string, status: number) {
    super(message, status);

    this.name = new.target.name;
    Object.setPrototypeOf(this, new.target.prototype);

    if ('captureStackTrace' in Error) {
      Error.captureStackTrace(this, new.target);
    }
  }
}
